import { useState } from 'react';
import { SIGNUP_STEPS } from '../../../types/enum';
import TextInput from '../../../components/textInput';

const Password = ({
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  setCurrentStep,
  handleSubmit,
  submitLoading,
}) => {
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleInput = (key) => (e) => {
    const value = String(e.target.value);
    if (key === 'password') {
      const passwordRegex = /^(?=.*[a-z])(?=.*\d)[\w\W]{8,}$/;
      if (passwordRegex.test(value)) {
        setPasswordError(false);
      }
      if (!passwordRegex.test(value) || value.length < 8 || value.length > 16) {
        setPasswordError(true);
      }
      setPassword(value);
    }
    if (key === 'confirmPassword') {
      if (password === value) {
        setConfirmPasswordError(false);
      }
      if (password !== value) {
        setConfirmPasswordError(true);
      }
      setConfirmPassword(value);
    }
  };

  const handleNext = async () => {
    try {
      await handleSubmit();
      setCurrentStep(SIGNUP_STEPS.GOAL);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <h1 className='font-bold text-white text-4xl mb-3'>Set your password</h1>
      <div className='relative'>
        <input
          type={showPassword ? 'text' : 'password'}
          className='w-full bg-white rounded-full py-2 px-4 '
          placeholder='Enter your password'
          value={password}
          onChange={handleInput('password')}
        />
        <button
          onClick={() => setShowPassword(!showPassword)}
          className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-black transition-colors'
        >
          {showPassword ? (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={1.5}
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z'
              />
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z'
              />
            </svg>
          ) : (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={1.5}
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88'
              />
            </svg>
          )}
        </button>
      </div>
      <p
        className={`text-xs mt-1 mb-3 font-bold ${
          passwordError ? 'text-red-600' : 'text-white'
        }`}
      >
        At least 8 characters long and contain at least one lowercase letter,
        and one number
      </p>
      <div className='relative'>
        <input
          type={showConfirmPassword ? 'text' : 'password'}
          className='w-full bg-white rounded-full py-2 px-4 '
          placeholder='Re-enter your password'
          value={confirmPassword}
          onChange={handleInput('confirmPassword')}
        />
        <button
          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-black transition-colors'
        >
          {showConfirmPassword ? (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={1.5}
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z'
              />
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z'
              />
            </svg>
          ) : (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={1.5}
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88'
              />
            </svg>
          )}
        </button>
      </div>
      {confirmPasswordError && (
        <p className='text-red-600 text-xs mt-1 font-bold'>
          Password must be the same
        </p>
      )}
      <button
        className={`w-full bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-600 transition-colors duration-200 py-3 mt-5 ${
          !password ||
          !confirmPassword ||
          passwordError ||
          confirmPasswordError ||
          submitLoading
            ? 'opacity-40'
            : 'hover:bg-gray-800 transition duration-200'
        }`}
        onClick={handleNext}
        disabled={
          !password ||
          !confirmPassword ||
          passwordError ||
          confirmPasswordError ||
          submitLoading
        }
      >
        Sign Up and Set Goals
      </button>
    </div>
  );
};

export default Password;
